import script from "./Markets.vue?vue&type=script&lang=ts&setup=true"
export * from "./Markets.vue?vue&type=script&lang=ts&setup=true"

import "./Markets.vue?vue&type=style&index=0&id=3c515644&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c515644"]])

export default __exports__